import { ViewScoreBreakdown } from '@/services/score/view';

interface ViewRecommendationProps {
  scoreData: ViewScoreBreakdown;
}

export const ViewRecommendation = ({ scoreData }: ViewRecommendationProps) => {
  const issues: string[] = [];

  // Check each component and identify weaknesses
  if (scoreData.openScore / 30 < 0.5) {
    issues.push('increase open sky views');
  }
  if (scoreData.vegetationScore / 20 < 0.4) {
    issues.push('add more greenery visibility');
  }
  if (scoreData.skyViewFactor / 10 < 0.5) {
    issues.push('improve overhead openness for natural light');
  }
  if (scoreData.horizontalOpenness / 10 < 0.5) {
    issues.push('reduce eye-level obstructions');
  }
  if (scoreData.viewDiversity / 7 < 0.4) {
    issues.push('enhance visual variety');
  }

  const score = scoreData.totalScore;

  if (score >= 7.0) {
    return <>Excellent view quality with great openness, natural elements, and visual diversity.</>;
  } else if (score >= 5.0) {
    if (issues.length > 0) {
      return <>Good view quality. To improve: {issues.slice(0, 2).join(', ')}.</>;
    }
    return <>Good view quality with balanced natural elements and openness.</>;
  } else if (score >= 3.0) {
    if (issues.length > 0) {
      return <>Moderate view quality. Focus on: {issues.slice(0, 2).join(', ')}.</>;
    }
    return <>Moderate view quality. Consider enhancing openness and diversity.</>;
  } else {
    if (issues.length > 0) {
      return <>Limited view quality. Priority improvements: {issues.slice(0, 3).join(', ')}.</>;
    }
    return <>Limited view quality. Significant improvements needed in openness and horizontal views.</>;
  }
};
